import { Instance } from 'mobx-state-tree';
import { BulkDeleteVisitsErrorDtoModelBase } from './BulkDeleteVisitsErrorDtoModel.base';

/* The TypeScript type of an instance of BulkDeleteVisitsErrorDtoModel */
export interface BulkDeleteVisitsErrorDtoModelType extends Instance<typeof BulkDeleteVisitsErrorDtoModel.Type> {}

/* A graphql query fragment builders for BulkDeleteVisitsErrorDtoModel */
export { selectFromBulkDeleteVisitsErrorDto, bulkDeleteVisitsErrorDtoModelPrimitives, BulkDeleteVisitsErrorDtoModelSelector } from './BulkDeleteVisitsErrorDtoModel.base';

/**
 * BulkDeleteVisitsErrorDtoModel
 */
export const BulkDeleteVisitsErrorDtoModel = BulkDeleteVisitsErrorDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
